import { Action } from '@ngrx/store';
import { LoginMethod } from './ui.reducer';

export const REQUEST_TYPE_FILTER_CHANGE = '[Request][Ui] type filter change';
export const REQUEST_CUSTOMER_FILTER_CHANGE = '[Request][Ui] customer filter change';
export const REQUEST_CUSTOMER_FILTER_RESET = '[Request][Ui] customer filter reset';
export const REQUEST_FEED_SEARCH = '[Request][Ui] feed search';
export const REQUEST_FEED_SEARCH_RESET = '[Request][Ui] feed search reset';
export const SET_LOGIN_METHOD = '[Auth][Set] Login method';

export class RequestTypeFilterChange implements Action {
  readonly type = REQUEST_TYPE_FILTER_CHANGE;
  constructor(public payload: String[]) {}
}

export class RequestCustomerFilterChange implements Action {
  readonly type = REQUEST_CUSTOMER_FILTER_CHANGE;
  constructor(public payload: string) {}
}

export class RequestCustomerFilterReset implements Action {
  readonly type = REQUEST_CUSTOMER_FILTER_RESET;
}

export class RequestFeedSearchAction implements Action {
  readonly type = REQUEST_FEED_SEARCH;
  constructor(public payload: string) {}
}

export class RequestFeedSearchResetAction implements Action {
  readonly type = REQUEST_FEED_SEARCH_RESET;
}

export class SetLoginMethod implements Action {
  readonly type = SET_LOGIN_METHOD;
  constructor(public payload: LoginMethod) {}
}
